import { InspectionfieldStateEnum } from "./__generated__/QueriesInspectionListQuery.graphql";

export const StateSorts: {
  [key in InspectionfieldStateEnum]?: (a: any, b: any) => number;
} = {
  ASSIGNED: (a, b) => {
    if (
      !a?.node?.periodEnd &&
      !b?.node?.periodEnd &&
      a?.node?.assignedDate &&
      b?.node?.assignedDate
    ) {
      // Sort based on assignment date if both periodEnds are missing
      return new Date(a?.node?.assignedDate).getTime() >
        new Date(b?.node?.assignedDate).getTime()
        ? 1
        : -1;
    }
    if (!a?.node?.periodEnd) return 1;
    if (!b?.node?.periodEnd) return -1;
    if (a?.node?.periodEnd && b?.node?.periodEnd) {
      return new Date(a.node.periodEnd).getTime() >
        new Date(b.node.periodEnd).getTime()
        ? 1
        : -1;
    }
    return 0;
  },
  PLANNED: (a, b) => {
    if (a?.node?.plannedDate && b?.node?.plannedDate) {
      return new Date(a?.node?.plannedDate).getTime() <
        new Date(b?.node?.plannedDate).getTime()
        ? -1
        : 1;
    }
    return 0;
  },
  IN_PROGRESS: (a, b) => {
    if (
      a?.node?.latestInspection?.lastModified &&
      b?.node?.latestInspection?.lastModified
    ) {
      return new Date(a?.node?.latestInspection.lastModified).getTime() <
        new Date(b?.node?.latestInspection.lastModified).getTime()
        ? -1
        : 1;
    }
    return 0;
  },
  APPROVED: (a, b) => {
    if (
      a?.node?.latestInspection?.approvedDate &&
      b?.node?.latestInspection?.approvedDate
    ) {
      return new Date(a?.node?.latestInspection.approvedDate).getTime() >
        new Date(b?.node?.latestInspection.approvedDate).getTime()
        ? -1
        : 1;
    }
    return 0;
  },
  REJECTED: (a, b) => {
    if (
      a?.node?.latestInspection?.rejectedDate &&
      b?.node?.latestInspection?.rejectedDate
    ) {
      return new Date(a?.node?.latestInspection.rejectedDate).getTime() >
        new Date(b?.node?.latestInspection.rejectedDate).getTime()
        ? -1
        : 1;
    }
    return 0;
  },
  RETRY: (a, b) => {
    if (
      a?.node?.latestInspection?.retryDate &&
      b?.node?.latestInspection?.retryDate
    ) {
      return new Date(a?.node?.latestInspection.retryDate).getTime() <
        new Date(b?.node?.latestInspection.retryDate).getTime()
        ? -1
        : 1;
    }
    return 0;
  },
};

export const StateColors: {
  [key in InspectionfieldStateEnum]?: string;
} = {
  ASSIGNED: "#0075BC",
  PLANNED: "#9D56E4",
  IN_PROGRESS: "#F9BF2B",
  APPROVED: "#309E5B",
  REJECTED: "#F92B2B",
  RETRY: "#F9BF2B",
};

export const StateTitles: {
  [key in InspectionfieldStateEnum]?: string;
} = {
  OPEN: "Open",
  IN_PROGRESS: "Bezig",
  ASSIGNED: "Toegewezen aan mij",
  PLANNED: "Ingepland",
  APPROVED: "Uitgevoerd: Akkoord",
  REJECTED: "Uitgevoerd: Niet akkoord",
  RETRY: "Uitgevoerd: Herstel",
};

export const ListColumnStates: InspectionfieldStateEnum[] = [
  "ASSIGNED",
  "PLANNED",
  "IN_PROGRESS",
  "REJECTED",
  "RETRY",
  "APPROVED",
];

export const GetTaskSort = (state: InspectionfieldStateEnum) => {
  return StateSorts[state] || ((a: any, b: any) => a - b);
};
